import { render, staticRenderFns } from "./_NewsForm.vue?vue&type=template&id=efdb1786&"
import script from "./_NewsForm.vue?vue&type=script&lang=ts&"
export * from "./_NewsForm.vue?vue&type=script&lang=ts&"
import style0 from "./_NewsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports